import { useEffect } from "react";
import AuthFormPresenter from "../../features/auth/components/AuthForm/AuthFormPresenter";
import { useAuth } from "../../features/auth/hooks";
import LoginLayout from "../../features/auth/layout/LoginLayout";
import { useNavigate } from "react-router-dom";
import { userRoles } from "../../features/user/types/user.types";

/**
 * LoginPage
 * @returns Component
 */
export default function LoginAdminPage() {
  const { userLogged, userRole } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      userRole === userRoles.SUPER_ADMIN
    ) {
      navigate("/sup-admin");
    }

    if ( userRole === userRoles.ADMIN) {
      navigate("/admin");
    }

    if ( userRole === userRoles.USER) {
      navigate("/user");
    }
  }, [userLogged]); // eslint-disable-line

  return (
    <LoginLayout>
        
      <AuthFormPresenter/>
    </LoginLayout>
  );
}
